import { SVGProps } from 'react';

export type EmptyBoxProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const EmptyBox = ({ size = 178, ...props }: EmptyBoxProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 178 178"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.8">
      <rect
        opacity="0.32"
        x="0.717529"
        width="176.53"
        height="176.53"
        rx="88.2648"
        fill="#E5E5E5"
      />
      <path
        d="M162.175 43.7947L162.175 138.471C162.175 140.86 160.238 142.797 157.849 142.797L20.1164 142.797C17.7278 142.797 15.7915 140.86 15.7913 138.471L15.7913 43.7947C15.7913 41.4058 17.7276 39.4686 20.1165 39.4685L157.849 39.4685C160.238 39.4685 162.175 41.4058 162.175 43.7947Z"
        fill="white"
        stroke="#666666"
        strokeWidth="1.44184"
      />
      <path
        d="M162.175 43.7964L162.175 46.6196C162.175 49.0086 160.238 50.9458 157.849 50.9458L20.1165 50.9458C17.7276 50.9457 15.7913 49.0085 15.7913 46.6196L15.7913 43.7964C15.7913 41.4075 17.7276 39.4703 20.1165 39.4702L157.849 39.4702C160.238 39.4702 162.175 41.4075 162.175 43.7964Z"
        fill="#E5E5E5"
        stroke="#666666"
        strokeWidth="1.44184"
      />
      <path
        d="M34.6257 45.2087C34.6257 46.4979 33.5808 47.5435 32.2917 47.5437L26.5505 47.5437C25.2614 47.5436 24.2166 46.4979 24.2166 45.2087C24.2167 43.9197 25.2615 42.8748 26.5505 42.8748L32.2917 42.8748C33.5807 42.8749 34.6256 43.9198 34.6257 45.2087Z"
        fill="#F2F3F4"
        stroke="#666666"
        strokeWidth="1.07214"
      />
      <path
        d="M49.6953 45.2087C49.6953 46.4979 48.6504 47.5435 47.3613 47.5437L41.6201 47.5437C40.331 47.5436 39.2861 46.4979 39.2861 45.2087C39.2863 43.9197 40.3311 42.8748 41.6201 42.8748L47.3613 42.8748C48.6503 42.8749 49.6952 43.9198 49.6953 45.2087Z"
        fill="#F2F3F4"
        stroke="#666666"
        strokeWidth="1.07214"
      />
      <path
        d="M64.7642 45.2087C64.7642 46.4979 63.7193 47.5435 62.4302 47.5437L56.689 47.5437C55.3998 47.5436 54.355 46.4979 54.355 45.2087C54.3551 43.9197 55.3999 42.8748 56.689 42.8748L62.4302 42.8748C63.7192 42.8749 64.764 43.9198 64.7642 45.2087Z"
        fill="#F2F3F4"
        stroke="#666666"
        strokeWidth="1.07214"
      />
      <ellipse
        opacity="0.34"
        cx="88.4048"
        cy="94.3846"
        rx="29.4017"
        ry="29.4017"
        fill="#EAEAEA"
      />
      <g opacity="0.8">
        <path
          d="M88.8123 109.734L101.063 102.67L96.364 99.9613L91.5619 102.729C91.5211 102.752 91.4749 102.763 91.4281 102.763C91.3812 102.763 91.3352 102.75 91.2946 102.727C91.2541 102.703 91.2204 102.67 91.1968 102.629C91.1731 102.589 91.1604 102.543 91.16 102.496V95.9173C91.1599 95.8231 91.1848 95.7304 91.232 95.6488C91.2793 95.5672 91.3472 95.4995 91.429 95.4525L97.1339 92.1627C97.1748 92.1396 97.2211 92.1276 97.2682 92.1278C97.3151 92.1281 97.3613 92.1405 97.402 92.164C97.4428 92.1874 97.4767 92.2211 97.5004 92.2616C97.5241 92.3021 97.5369 92.3481 97.5374 92.395V97.9298L102.236 100.639V86.5125L88.8123 94.2526V109.734Z"
          fill="#434343"
        />
        <path
          d="M89.9873 79.449V84.8676L94.7869 87.635C94.8272 87.6588 94.8607 87.6927 94.8839 87.7334C94.9072 87.7741 94.9194 87.8201 94.9194 87.867C94.9194 87.9138 94.9072 87.9598 94.8839 88.0005C94.8607 88.0412 94.8272 88.0751 94.7869 88.099L89.082 91.3889C89.0002 91.436 88.9074 91.4608 88.813 91.4608C88.7185 91.4608 88.6258 91.436 88.5439 91.3889L82.8383 88.1023C82.7979 88.0783 82.7645 88.0443 82.7413 88.0036C82.718 87.9628 82.7058 87.9167 82.7058 87.8699C82.7058 87.8229 82.718 87.7769 82.7413 87.7361C82.7645 87.6954 82.7979 87.6614 82.8383 87.6374L87.6379 84.8709V79.449L75.3872 86.5125L88.8121 94.2526L102.237 86.5125L89.9873 79.449Z"
          fill="#434343"
        />
        <path
          d="M86.0625 102.729L81.2604 99.9613L76.5623 102.67L88.8121 109.734V94.2526L75.3872 86.5125V100.639L80.0861 97.9298V92.3942C80.0869 92.3474 80.0998 92.3017 80.1235 92.2614C80.1473 92.2211 80.1811 92.1877 80.2217 92.1643C80.2623 92.141 80.3082 92.1286 80.355 92.1282C80.4018 92.128 80.448 92.1398 80.4888 92.1627L86.1978 95.4525C86.2795 95.4996 86.3472 95.5673 86.3944 95.649C86.4415 95.7306 86.4662 95.8232 86.466 95.9173V102.496C86.4658 102.543 86.4534 102.59 86.4297 102.63C86.4061 102.671 86.3722 102.705 86.3313 102.729C86.2905 102.752 86.2442 102.765 86.197 102.765C86.1499 102.765 86.1035 102.753 86.0625 102.729Z"
          fill="#434343"
        />
      </g>
    </g>
  </svg>
);
